import axios from "axios"
import { useEffect, useState } from "react"
import { UserInfo} from "../types"
import StaffComponent from "./staff-component"
import UserComponent from "./user-component"
import { Container, Heading } from "@chakra-ui/react"
import { api_url } from "@/variables"

const RegistrationComponent = (props: any) => {
    const user: UserInfo = props.user

    const [registered, setRegistered] = useState(false)
    const [checkingRegistration, setCheckingRegistration] = useState(true)
    const [userRole, setUserRole] = useState<string>("")

    useEffect(() => {
        const checkUserRegistration = async () => {
            try {
                const response = await axios.get(`${api_url}/users/${user.telegram_id}`, 
                );
                console.log(response)
                
                if( response.data != "" ) {
                    setRegistered(true)
                    setUserRole(response.data[0].role)

                    console.log(response)
                }

                setCheckingRegistration(false)

            } catch (error) {
                console.error(error);
            }

        };
        checkUserRegistration()

        
    }, [])

    return (
        <Container bg="grackle.600" style={
            {
                textAlign: "center",
                marginBottom: "5px"
            }
        }>
            <Heading size="lg" bg="grackle.900">Welcome { user.name }!</Heading>
            { !checkingRegistration && registered && 
                <div>
                    { ["administrator", "staff"].includes(userRole) && 
                        <StaffComponent />
                    }
                    { userRole == "banned" &&
                        <span>Please contact a staff member for assistance.</span>
                    }
                    { userRole == "registered" &&
                        <span>
                            Your registration request is pending. 
                            Please allow up to 24 hours after submission for approval.
                        </span>
                    }
                    { userRole == "approved" &&
                        <UserComponent />
                    }
                </div>
            }
            { !checkingRegistration && !registered &&
                <p>
                    This appears to be your first time here!
                    Please tap the link to let someone know you'd like
                    to register for events- you should receive a response 
                    within 24 hours.
                </p>
            }
            { checkingRegistration &&
                <span>Checking registration...</span>
            }
        </Container>
    )
}

export default RegistrationComponent